<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column prop="TeacherName" label="用户姓名" min-width="120px" />
      <el-table-column prop="LoginId" label="用户账号" min-width="120px" />
      <el-table-column prop="RoleName" label="角色名称" min-width="120px" />
      <el-table-column prop="Status" width="80px" label="状态" align="center">
        <template slot-scope="{row}">
          <el-tag size="mini" type="success" v-if="row.Status == 1">启用</el-tag>
          <el-tag size="mini" type="danger" v-else>停用</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/sy/user").default,
      data: [],
      params: {},
      title: "导出 用户信息",
    };
  },
  methods: {
    getData(params) {
      this.params = this.$commonJs.obj.removeNullKey(params);
      this.$refs.dialog.isLoading = true;
      this.api.list(this.params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>